module.exports = __webpack_public_path__ + "img/storage.ebd8518b.svg";